import * as plugins from '../plugins.js';

export type TStateTypes = 'IAccountState';
export interface IAccountState {
  user: plugins.lointReception.data.IUser;
  /**
   * the available orgs
   */
  organizations: Array<plugins.lointReception.data.IOrganization>;
  roles: Array<plugins.lointReception.data.IRole>

  selectedOrg: plugins.lointReception.data.IOrganization;
  selectedOrgBillingPlan: plugins.typeFest.PartialDeep<plugins.lointReception.data.IBillingPlan>;

  /**
   * used for keeping the state when creating a new org
   */
  newOrg: {
    chosenName: string;
    chosenSlug: string;
    validated: boolean;
    validationOk: boolean;
  };
}

const smartStateInstance = new plugins.domtools.plugins.smartstate.Smartstate<TStateTypes>();
export const receptionClient = new plugins.leleReceptionclient.LeleReceptionClient(
  window.location.hostname.includes('localhost')
    ? 'http://localhost:3001'
    : 'https://reception.lossless.one:443'
);
export const accountState = smartStateInstance.getStatePart<IAccountState>('IAccountState', {
  user: null,
  organizations: [],
  roles: [],
  selectedOrg: null,
  selectedOrgBillingPlan: null,
  newOrg: {
    chosenName: null,
    chosenSlug: null,
    validated: null,
    validationOk: null,
  },
});

export const getOrganizationsAction = accountState.createAction<void>(
  async (statePartArg, payloadArg) => {
    const currentState = statePartArg.getState();
    const response = await receptionClient.getRolesAndOrganizations();
    currentState.organizations = response.organizations;
    currentState.roles = response.roles;
    return currentState;
  }
);

export const setNewOrgName = accountState.createAction<string>(async (statePartArg, payloadArg) => {
  const currentState = statePartArg.getState();
  currentState.newOrg.chosenName = payloadArg;
  currentState.newOrg.chosenSlug = payloadArg
    .replace(/[^a-zA-Z0-9]/g, '-')
    .replace(/\s/g, '-')
    .toLowerCase();
  const result = await receptionClient.createOrganization(
    currentState.newOrg.chosenName,
    currentState.newOrg.chosenSlug,
    'checkAvailability'
  );
  console.log(result);
  currentState.newOrg.validated = true;
  currentState.newOrg.validationOk = result.nameAvailable;
  if (payloadArg === '') {
    currentState.newOrg.validated = false;
    currentState.newOrg.validationOk = false;
  }
  return currentState;
});

export const manifestNewOrgName = accountState.createAction(async (statePartArg, payloadArg) => {
  const currentState: IAccountState = statePartArg.getState();
  const result = await receptionClient.createOrganization(
    currentState.newOrg.chosenName,
    currentState.newOrg.chosenSlug,
    'manifest'
  );
  currentState.organizations.push(result.resultingOrganization);
  currentState.selectedOrg = result.resultingOrganization;
  return currentState;
});

export const setSelectedOrg = accountState.createAction<plugins.lointReception.data.IOrganization>(async (statePartArg, payloadArg) => {
  const currentState = statePartArg.getState();
  currentState.selectedOrg = payloadArg;
  return currentState;
})

export const updatePaddleCheckoutId = accountState.createAction<string>(async (statePartArg, checkoutIdArg) => {
  const currentState: IAccountState = statePartArg.getState();
  const response = await receptionClient.updatePaddleCheckoutId(currentState.selectedOrg.id, checkoutIdArg);
  currentState.selectedOrgBillingPlan = response.billingPlan;
  return currentState;
});
